module.exports = __webpack_public_path__ + "static/3-39de0715a960444695aa428fbae7768a.jpg";